import { useSearchParams } from 'react-router-dom';

import { targetResourceSelector } from '@/util/selectorGenerators';

/** Defaults to the select search param, then 1+current_fqn+1, then undefined */
export const useCurrentSelector = (fqn: string | undefined | null) => {
  const [searchParams] = useSearchParams();
  const selectParam = searchParams.get('select');
  if (selectParam) return selectParam;
  if (!fqn) return undefined;
  return targetResourceSelector({ fqn: [fqn], depth: 1 });
};
